import type { ReactNode } from 'react';
import { AppContext, type AppContextValue } from './context';

export function AppProvider({
  children,
  ...value
}: AppContextValue & { readonly children: ReactNode }) {
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
